import React from 'react';
import classnames from 'classnames';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { CURRENCIES } from 'common/constants/payment';
import formatPrice from '../../utils/format-price';

const styles = makeStyles(({ palette, spacing }: any) => ({
  root: {
    borderTop: `1px solid ${palette.background.total}`,
    padding: `${spacing(2)}px ${spacing(3)}px ${spacing(2)}px ${spacing(3)}px`,
    backgroundColor: palette.background.total,
  },
  removeBackgroundClass: {
    backgroundColor: palette.common.white,
  },
  outstandingAmountText: {
    fontWeight: 'normal',
  },
}));

interface GrandTotalProps {
  grandTotal: number;
  grandTotalCopy: string;
  currency?: string;
  removeBackground?: boolean;
}

const GrandTotal = ({
  grandTotal,
  grandTotalCopy,
  currency = CURRENCIES.GBP,
  removeBackground = false,
}: GrandTotalProps) => {
  const classes = styles();
  const totalPaid = classnames({
    [classes.removeBackgroundClass]: removeBackground,
  });

  return (
    <Grid
      container
      justifyContent="space-between"
      data-testid="billGrandTotal"
      className={`${classes.root} ${totalPaid}`}
    >
      <Typography variant="h3">
        <strong>{`${grandTotalCopy} `}</strong>
      </Typography>
      <Typography
        className={classes.outstandingAmountText}
        variant="h3"
        data-testid="outstanding-amount"
      >
        {formatPrice(grandTotal, currency)}
      </Typography>
    </Grid>
  );
};

export default GrandTotal;
